import React from 'react';

export function useConfirmModal(initial = false) {
  const [visible, setVisible] = React.useState<boolean>(initial);
  const open = React.useCallback(() => setVisible(true), []);
  const close = React.useCallback(() => setVisible(false), []);
  return { visible, open, close } as const;
}


